import { DataTestId } from '../../core/types/data-props.js';
import { DOMProps } from '../../core/types/dom.js';
import { StylingProps } from '../../core/types/styling-props.js';
import { WithChildren } from '../../core/types/with-children.js';
import { Paragraph } from '../../typography/paragraph/Paragraph.js';
import { Text } from '../../typography/text/Text.js';

//#region Typings
/**
 * @public
 */
export interface TerminologyDescriptionProps
  extends DOMProps,
    WithChildren,
    StylingProps,
    DataTestId {}
//#endregion Typings

/**
 * Adds the description for the terminology to help the user.
 * @public
 */
export const Description = (props: TerminologyDescriptionProps) => {
  const {
    children,
    id,
    className: consumerClassName,
    style: consumerStyle,
    'data-testid': dataTestId,
  } = props;
  if (typeof children === 'string') {
    return (
      <Paragraph
        id={id}
        data-testid={dataTestId}
        className={consumerClassName}
        style={consumerStyle}
      >
        {children}
      </Paragraph>
    );
  }
  return (
    <Text as="div" textStyle="base" id={id}>
      {children}
    </Text>
  );
};

Description.displayName = 'TerminologyOverlay.Description';
